import axios from '../axios';

const banksAPI = {
  getAll: async () => {
    const response = await axios.get('/banks');
    return response.data;
  },

  getById: async (id) => {
    const response = await axios.get(`/banks/${id}`);
    return response.data;
  },

  create: async (bankData) => {
    const response = await axios.post('/banks', bankData);
    return response.data;
  },

  update: async (id, bankData) => {
    const response = await axios.put(`/banks/${id}`, bankData);
    return response.data;
  },

  delete: async (id) => {
    const response = await axios.delete(`/banks/${id}`);
    return response.data;
  },

  getTransactions: async (id) => {
    const response = await axios.get(`/banks/${id}/transactions`);
    return response.data;
  }
};

export default banksAPI; 